<template>
    <div>
        <b-modal
            id="switch-tab-popup"
            ref="modal"
            title="Confirm Switch"
            size="sm"
            hide-footer
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
        >
            <b-form @submit.stop.prevent="switchTab()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <p>
                            Are you sure to want to switch this tab ? Your
                            changes will be lost if you switch this tab now
                        </p>
                    </div>
                </div>

                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Switch"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */

        list: {
            type: Array,
        },
        index: {
            type: Number,
        },
    }, // End of Component > props

    data() {
        return {
            listing: [],
            deleteIndex: '',
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        list(value) {
            if (value) {
                this.listing = value
            }
        },
        index(value) {
            this.deleteIndex = value
        },
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    },
    methods: {
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */

        switchTab() {
            let self = this
            this.$store.commit('setLoading', true)
            this.$emit('tab-switch', true)
            setTimeout(function () {
                self.$store.commit('setLoading', false)
                self.$refs.modal.hide()
            }, 1000)
        },

        hideModal() {
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > computed

    mounted() {
        this.listing = this.list
    },
}
</script>
